import React from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined, SaveOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const UnsavedChangesModal = ({
    visible,
    onClose,
    onSave,
    onDiscard,
    onCancel,
    loading,
    isRTL,
    dmode
}) => {
    const { t } = useTranslation();
    return (
        <Modal
            title={
                <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px',
                    fontFamily: 'Mulish, sans-serif',
                    fontWeight: '700',
                    color: dmode ? '#ccc' : '#333333'
                }}>
                    <ExclamationCircleOutlined style={{ color: '#FAAD14', fontSize: '18px' }} />
                    {t('UNSAVED_CHANGES')}
                </div>
            }
            open={visible}
            onCancel={onCancel || onClose}
            centered
            width={450}
            footer={null}
            maskClosable={!loading}
            closable={!loading}
            bodyStyle={{ 
                padding: '24px',
                fontFamily: 'Mulish, sans-serif',
                backgroundColor: dmode ? '#2f353e' : '#fff'
            }}
            style={{
                direction: isRTL ? 'rtl' : 'ltr'
            }}
            zIndex={9999}
            styles={{
                header: {
                    backgroundColor: dmode ? '#2f353e' : '#fff',
                    borderBottom: 'none'
                },
                body: {
                    backgroundColor: dmode ? '#2f353e' : '#fff'
                },
                content: {
                    backgroundColor: dmode ? '#2f353e' : '#fff'
                }
            }}
        >
            <div style={{ marginBottom: '24px' }}>
                <p style={{ 
                    fontSize: '14px', 
                    color: dmode ? '#999' : '#666666', 
                    marginBottom: '16px',
                    lineHeight: '1.5'
                }}>
                    {t('UNSAVED_CHANGES_MESSAGE')}
                </p>
            </div>

            <div style={{
                display: 'flex',
                justifyContent: isRTL ? 'flex-start' : 'flex-end',
                gap: '12px',
                direction: isRTL ? 'rtl' : 'ltr'
            }}>
                <Button
                    onClick={onCancel || onClose}
                    disabled={loading}
                    style={{
                        fontFamily: 'Mulish, sans-serif',
                        fontWeight: '600',
                        height: '36px',
                        minWidth: '80px',
                        backgroundColor: dmode ? '#3a4149' : '#fff',
                        borderColor: dmode ? '#555' : '#d9d9d9',
                        color: dmode ? '#ccc' : '#333'
                    }}
                >
                    {t('CANCEL')}
                </Button>
                <Button
                    onClick={onDiscard}
                    disabled={loading}
                    style={{
                        fontFamily: 'Mulish, sans-serif',
                        fontWeight: '600',
                        height: '36px',
                        minWidth: '80px',
                        backgroundColor: dmode ? '#3a4149' : '#fff',
                        borderColor: dmode ? '#555' : '#d9d9d9',
                        color: dmode ? '#ccc' : '#333'
                    }}
                >
                    {t('DISCARD')}
                </Button>
                <Button
                    type="primary"
                    onClick={onSave}
                    loading={loading}
                    icon={!loading ? <SaveOutlined /> : null}
                    style={{
                        backgroundColor: '#1890FF',
                        borderColor: '#1890FF',
                        fontFamily: 'Mulish, sans-serif',
                        fontWeight: '600',
                        height: '36px',
                        minWidth: '100px'
                    }}
                >
                    {loading ? t('SAVING') : t('SAVE')}
                </Button>
            </div>
        </Modal>
    );
};

export default UnsavedChangesModal;